var _circle, _path, _circle2, _path2, _circle3, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHoursResourcesDarkIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 19,
    viewBox: "0 0 30 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6185,
    cy: 6.15752,
    r: 5.63653,
    fill: "white",
    stroke: "#189477",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6331 17.2489C28.3552 14.4548 26.7668 11.9212 24.0251 11.0913C23.1987 11.6013 21.6965 11.9136 20.619 11.9373C19.5415 11.9139 18.0393 11.6016 17.2129 11.0913C14.4712 11.9212 12.8828 14.4548 12.6049 17.2489C12.6049 17.2489 12.4119 18.3213 13.5368 18.3213H27.7012C28.826 18.3213 28.6331 17.2489 28.6331 17.2489Z",
    fill: "white",
    stroke: "#189477",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.20977,
    cy: 6.15752,
    r: 5.63653,
    fill: "white",
    stroke: "#189477",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2244 17.2489C15.9465 14.4548 14.3581 11.9212 11.6164 11.0913C10.79 11.6013 9.28776 11.9136 8.21029 11.9373C7.13281 11.9139 5.6306 11.6016 4.80418 11.0913C2.0625 11.9212 0.474078 14.4548 0.196183 17.2489C0.196183 17.2489 0.00323564 18.3213 1.12808 18.3213H15.2925C16.4173 18.3213 16.2244 17.2489 16.2244 17.2489Z",
    fill: "white",
    stroke: "#189477",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.0315,
    cy: 6.15752,
    r: 5.63653,
    fill: "white",
    stroke: "#189477",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0462 17.2489C21.7683 14.4548 20.1799 11.9212 17.4382 11.0913C16.6117 11.6013 15.1095 11.9136 14.0321 11.9373C12.9546 11.9139 11.4524 11.6016 10.626 11.0913C7.88428 11.9212 6.29586 14.4548 6.01796 17.2489C6.01796 17.2489 5.82501 18.3213 6.94986 18.3213H21.1143C22.2391 18.3213 22.0462 17.2489 22.0462 17.2489Z",
    fill: "white",
    stroke: "#189477",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoursResourcesDarkIcon);
export default __webpack_public_path__ + "static/media/hours-resources-dark-icon.467eda21b82235c0caa4f565fd27ea08.svg";
export { ForwardRef as ReactComponent };